import {Box, SvgIcon, SvgIconProps} from "@mui/material";
import {MapIconProps} from "./MapIcon";
import {UsersIconProps} from "./UsersIcon";

export interface DevicesIconProps extends SvgIconProps {
    scolor?: string;
}

const DevicesIcon =   ({ scolor = "#78909C", ...props }: UsersIconProps) => {
    return (
        <SvgIcon style={{fill: "none"}} {...props}>
            <path d="M0 0h24v24H0V0"/>
            <Box strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                 d="M4.586 4.586A2 2 0 0 1 6 4h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 .586-1.414Zm10 0A2 2 0 0 1 16 4h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V6a2 2 0 0 1 .586-1.414Zm-10 10A2 2 0 0 1 6 14h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a2 2 0 0 1 .586-1.414Zm10 0A2 2 0 0 1 16 14h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 .586-1.414Z"
                 component="path" sx={{
                                         stroke: scolor,
                                         '&:hover': {
                                             stroke: 'white', // Background color on hover
                                         },
                                     }}/></SvgIcon>
    );
};

export default DevicesIcon;